import { render, staticRenderFns } from "./modalForm.vue?vue&type=template&id=054389ec"
import script from "./modalForm.vue?vue&type=script&lang=js"
export * from "./modalForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports